import React, { PropsWithChildren, ReactElement } from 'react';

export type BoxSelectorsGroupProps = PropsWithChildren<unknown>;

export const BoxSelectorsGroup = ({
  children,
}: BoxSelectorsGroupProps): ReactElement => (
  <g id="boxSelectorsGroup">{children}</g>
);
